import React from "react";
import { CardLayout } from "components/cardLayout";
import "./EstimatorDetailCard.scss"
import {getEstimatorDetails} from 'core/services/getEstimatorDetailsService'
import Spinner from '../spinner/spinner';

export interface EstimatorDetailCardProps {
    
}
 
export interface EstimatorDetailCardState {
    Estimator:any;
    loading:boolean;
    
}
 
class EstimatorDetailCard extends React.Component<EstimatorDetailCardProps, EstimatorDetailCardState> {
    private _isMounted: boolean = false;
    constructor(props: EstimatorDetailCardProps) {
        super(props);
        this.state = { 
            Estimator:[],
            loading:false
         };
    }
    async fetchData() {
        var CID = localStorage.getItem("CID")||"0";
        let response = await getEstimatorDetails(CID)
        localStorage.setItem("EstiamtorEmail",response[0].estimatorEmail);
        //alert(response[0].estimatorEmail);
        this.setState({Estimator:response[0],loading:false})
        console.log(this.state.Estimator)
    }
    
    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
        this.setState ({loading:true});

    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() { 

        

        return (  
           // this.state.loading?<Spinner/>:
            <CardLayout>
                {/* <div className="estimator-img">
                </div> */}
                {/* <div className="estimator-detail">
                <h1> Estimator name</h1>
                <p>estimator@allmysons.com</p>
                <p>2400 Old Mill Rd.</p>
                <p>Carrollton, TX 75007</p>
                <p>Cell: (214) 650-9917</p>
                <p>  Office: (214) 666-6289</p>  
                </div> */}
                <div className="estimator-detail">
                    <p>Your Estimator:</p>
            <h3><span>{this.state.Estimator.estimatorName}</span></h3>
                </div>
                <div className="estimator-detail">
                    <p>Phone:</p>
                    <h3>{this.state.Estimator.estimatorPh}</h3>
                </div>
                <div className="estimator-detail">
                    <p>Email:</p>
            <h3>{this.state.Estimator.estimatorEmail}</h3>
                </div>
                <div className="estimator-detail">
                    <p>Office Phone:</p>
            <h3>{this.state.Estimator.callBackPhone}</h3>
                </div>
                <div className="estimator-detail">
                    <p>Office Address:</p>
            <h3>{this.state.Estimator.carrierAdd1 + "" + this.state.Estimator.carrierAdd2}</h3>
                </div>
            </CardLayout>
         );
    }
}
 
export default EstimatorDetailCard;